<template>
	<div class="m_container" :class="openType != 'mob' ? 'flex_center flex_items vh100' : ''">
		<div class="content plr20 bgfff" style="box-sizing: border-box;"
			:class="openType != 'mob' ? 'container_w_h' : ''" :style="openType != 'mob' ? '' : 'min-height:100vh'">
			<div class="bor_b pb20 flex list-content pt20" v-if="!this.id">
				<div class="name">用户名</div><input v-model="username" type="text" placeholder="请输入用户名" />
			</div>
			<div class="bor_b pb20 flex list-content pt20">
				<div class="name">姓名</div><input type="text" placeholder="请输入姓名" v-model="name" />
			</div>
			<div class="bor_b pb20 flex list-content pt20">
				<div class="name">电话号码</div><input type="text" placeholder="请输入电话号码" v-model="phone" />
			</div>
			<div class="bor_b pb20 flex list-content pt20">
				<div class="name">角色</div>
				<RadioGroup v-model="role" checked-color="#00D8CC" direction="horizontal">
					<Radio name="member" class="mb10" style="margin-right: 20px;">会员</Radio>
					<Radio name="officer" class="mb10">工作人员</Radio>
					<Radio name="manager">管控</Radio>
				</RadioGroup>
			</div>
			<div class="bor_b pb20 flex list-content pt20">
				<div class="name">状态</div>
				<RadioGroup v-model="status" checked-color="#00D8CC" direction="horizontal">
					<Radio :name="1">正常</Radio>
					<Radio :name="0">停用</Radio>
				</RadioGroup>
			</div>
			<template v-if="!this.id">
				<div class="bor_b pb20 flex list-content pt20">
					<div class="name">密码</div><input type="password" placeholder="请输入密码" v-model="password" />
				</div>
				<div class="bor_b pb20 flex list-content pt20">
					<div class="name">确认密码</div><input type="password" placeholder="请输入密码" v-model="repassword" />
				</div>
			</template>
			<div class="btn" style="margin-top: 30px;">
				<div class="btn_contenbt main_bg cf txt_center b_r_10" style="height: 50px; line-height: 50px;"
					@click="submit">提交</div>
			</div>
			<div class="mt20 red txt_center" @click="del" style="border-bottom: 1px solid;width: 88px;margin: 0 auto;margin-top: 20px;"
				v-if="id">删除账号</div>
			<!-- <div class="bottom_btn">
				<div class="btn_contenbt" @click="submit">提交</div>
			</div> -->
		</div>
	</div>
</template>

<script>
	import {
		RadioGroup,
		Radio,Dialog
	} from "vant";
	import {
		openType
	} from '@/utils/tool.js'
	export default {
		components: {
			RadioGroup,
			Radio
		},
		data() {
			return {
				name: '',
				username: '',
				password: '',
				repassword: '',
				phone: '',
				openType: openType(),
				status: 1,
				role: 'member',
				flag: true,
				id: ''
			}
		},
		methods: {
			getList() {
				this.api.planList({}, this.id).then(res => {
					this.list = res.data
				})
			},
			del() {
				Dialog.confirm({
						title: '删除',
						message: '确定删除此账号？',
					})
					.then(() => {
						this.api.accountDelete({}, this.id).then(res => {
							this.Toast('删除成功')
							setTimeout(() =>{
								window.history.go(-2)
							},1500)
						})
					})
					.catch(() => {
						// on cancel
					});
			},
			submit() {
				if (!this.id) {
					if (this.username == '') {
						this.Toast('请填写用户名')
						return
					}
				}

				if (!this.name) {
					this.Toast('请填写姓名')
					return
				}
				if (!/^1[34578]\d{9}$/.test(this.phone)) {
					this.Toast("手机号码有误，请重填");
					return
				}
				
				if (!this.id) {
					if (!this.password || this.password != this.repassword) {
						this.Toast('密码有误')
						return
					}
				}
				if (!this.flag) {
					return
				}
				this.flag = false;
				if (!this.id) {
					let obj = {
						username: this.username,
						password: this.password,
						name: this.name,
						phone: this.phone,
						role: this.role,
						status: this.status,
					}
					this.api.accountNew(obj).then(res => {
						this.Toast('添加成功')
						setTimeout(() => {
							window.history.go(-1)
						}, 1500)
						this.flag = true
					}).catch(() => {
						this.flag = true
					})
				} else {
					//修改
					let obj = {
						name: this.name,
						phone: this.phone,
						role: this.role,
						status: this.status,
					}
					this.api.accountUpdate(obj, this.id).then(res => {
						this.Toast('修改成功')
						setTimeout(() => {
							window.history.go(-1)
						}, 1500)
						this.flag = true
					}).catch(() => {
						this.flag = true
					})
				}

			},
			accountView() {
				this.api.accountView({}, this.id).then(res => {
					let r = res.data;
					this.username = r.username;
					this.name = r.name;
					this.phone = r.phone;
					this.role = r.role == 'admin' ? 'manager' : r.role;
					this.status = r.status;
				})
			}
		},
		created() {
			this.id = this.$route.query.id
			this.openType = openType();
			if (this.id) {
				this.accountView()
			}
		}
	}
</script>

<style scoped="scoped">
	.content {
		padding-bottom: 90px;
		/* height: 100vh; */
		overflow-y: auto;
	}

	.name {
		width: 100px;
	}

	input {
		flex: 1;
	}
</style>
